import { useCallback, useMemo, useState } from 'react';
import { addDays, mondayOf, startOfDayISO, todayIn } from './time';

export function useWeek(tz) {
  const today = todayIn(tz);
  const [weekStart, setWeekStart] = useState(() => mondayOf(today));

  const prev = useCallback(() => setWeekStart((w) => addDays(w, -7)), []);
  const next = useCallback(() => setWeekStart((w) => addDays(w, 7)), []);
  const reset = useCallback(() => setWeekStart(mondayOf(todayIn(tz))), [tz]);

  const days = useMemo(() => Array.from({ length: 7 }, (_, i) => addDays(weekStart, i)), [weekStart]);
  const range = useMemo(
    () => ({ from: startOfDayISO(weekStart, tz), to: startOfDayISO(addDays(weekStart, 7), tz) }),
    [weekStart, tz]
  );

  return { today, weekStart, days, range, prev, next, reset, isCurrent: weekStart === mondayOf(today) };
}
